import { Observable, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MatSort } from '@angular/material/sort';
import { Country } from 'src/app/shared/models/country';
import { environment } from 'src/environments/environment';
import { CompanyTypeEnum } from './invoice-form-type.enum';
import { MatTableDataSource } from '@angular/material/table';
import { Companies } from './../../../../core/models/companies';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { PermissionsEnum } from 'src/app/core/enums/permissions.enum';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CompanyService } from 'src/app/core/services/company.service';
import { allCountries } from './../../../../core/models/all-countries';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { debounceTime, switchMap, takeUntil, shareReplay } from 'rxjs/operators';
import { CompanyPreview } from 'src/app/core/interfaces/company-preview.interface';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { pageConfig } from 'src/app/modules/easy-trade/actions/query-list-involved-companies.action';
import { QueryListInvolvedCompanies } from './../../../easy-trade/Models/query-list-involved-companies';
import { AddNotEllosCompanyManagerDialogComponent } from 'src/app/modules/easy-trade/components/add-not-ellos-company-manager-dialog/add-not-ellos-company-manager-dialog.component';
import { start } from 'repl';

@Component({
  selector: 'app-company-management-settings',
  templateUrl: './company-management-settings.component.html',
  styleUrls: ['./company-management-settings.component.scss']
})
export class CompanyManagementSettingsComponent implements OnInit {
  public modules = [];
  public modulePermission = PermissionsEnum;
  displayedColumns: string[] = ['favorite', 'id', 'name', 'street', 'idCountry', 'poBox', 'actions'];
  destroy$ = new Subject<any>();
  @Output() companySelected = new EventEmitter<any>();
  @Output() closeTableEvent = new EventEmitter<any>();
  dataSource: MatTableDataSource<Companies> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  queryListInvolvedCompanies$: Observable<QueryListInvolvedCompanies>;
  radioStatus: boolean;
  query: QueryListInvolvedCompanies;
  pageIndex = 0;
  pageSize = 10;
  @ViewChild('empTbSort') empTbSort = new MatSort();
  pageSizeOptions: number[] = [5, 10, 25, 100];
  count: number;
  @Input() typeCompany: CompanyTypeEnum;
  @Input() countries: Country[] = [];
  dialogRefEditCompany;
  loading: boolean = false;
  inputSearch: FormControl;
  companiesSession: CompanyPreview[] = [];
  faSignOutAlt = faSignOutAlt;

  constructor(
    private readonly queryListInvolvedCompaniesStore: Store<{
      queryListInvolvedCompanies: QueryListInvolvedCompanies;
    }>,
    private readonly dialog: MatDialog,
    private readonly translateService: TranslateService,
    private readonly companyService: CompanyService,
    private readonly permissions: PermissionsService,
    private readonly sessionCompaniesState: Store<{
      sessionCompanies: CompanyPreview[];
    }>
  ) {
    this.queryListInvolvedCompanies$ = queryListInvolvedCompaniesStore.pipe(select('queryListInvolvedCompanies'));
  }

  async ngOnInit() {
    this.inputSearch = new FormControl('');
    this.inputSearch.valueChanges
      .pipe(
        debounceTime(400),
        switchMap(async (value) => {
          await this.getListInvolvedCompanies(value);
        })
      )
      .subscribe((result) => {});

    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((t) => {
      if (!environment.production) {
        let itemsPerPageLabel = this.translateService.instant(`mat-table.itemsPerPageLabel`);
        let nextPageLabel = this.translateService.instant(`mat-table.nextPageLabel`);
        let firstPageLabel = this.translateService.instant(`mat-table.firstPageLabel`);
        let lastPageLabel = this.translateService.instant(`mat-table.lastPageLabel`);
        let previousPageLabel = this.translateService.instant(`mat-table.previousPageLabel`);
        if (this.paginator) {
          this.paginator._intl.itemsPerPageLabel = itemsPerPageLabel;
          this.paginator._intl.nextPageLabel = nextPageLabel;
          this.paginator._intl.firstPageLabel = firstPageLabel;
          this.paginator._intl.lastPageLabel = lastPageLabel;
          this.paginator._intl.previousPageLabel = previousPageLabel;
          this.paginator._intl.changes.next(itemsPerPageLabel);
          this.paginator._intl.changes.next(nextPageLabel);
          this.paginator._intl.changes.next(lastPageLabel);
          this.paginator._intl.changes.next(previousPageLabel);
        }
      }
    });

    this.queryListInvolvedCompanies$.pipe(takeUntil(this.destroy$), shareReplay(1)).subscribe(async (query) => {
      if (query) {
        this.query = query;
        this.pageIndex = query.PageIndex;
        await this.getListInvolvedCompanies();
      }
    });

    this.modules = this.permissions.getPermissionStorage();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.empTbSort;
  }

  async favoriteCompany(company: any, favorite: boolean) {
    this.loading = true;

    let response = await this.companyService.favoriteCompanie(company?.id, favorite);

    if (response?.success) {
      this.dataSource.data = this.dataSource.data.map((obj) => {
        if (obj.id === company?.id) {
          if (favorite) {
            obj.favorite = true;
          } else {
            obj.favorite = false;
          }
        }
        return obj;
      });

      this.dataSource.data.sort((a, b) => {
        if (a.favorite === b.favorite) {
          return 0;
        }
        return a.favorite ? -1 : 1;
      });

      this.dataSource._updateChangeSubscription();
    }

    this.loading = false;
  }

  get companyTypeEnum() {
    return CompanyTypeEnum;
  }

  async getListInvolvedCompanies(nameCompany?: string) {
    try {
      this.loading = true;
      let response;

      if (nameCompany) {
        response = await this.companyService.getListInvolvedCompaniesByName(this.query, nameCompany);
      } else {
        response = await this.companyService.getListInvolvedCompanies(this.query);
      }

      if (response.companyCount > 0 && response.companies.length > 0) {
        response.companies.forEach((element) => {
          element.country = allCountries.find((idCountry) => idCountry.id === element.idCountry);
        });

        response.companies.sort((a, b) => {
          if (a.favorite === b.favorite) {
            return 0;
          }
          return a.favorite ? -1 : 1;
        });

        this.dataSource.data = response.companies;
        this.count = response.companyCount;
      } else {
        this.count = 0;
        this.dataSource.data = [];
      }
    } catch {
      this.count = 0;
      this.dataSource.data = [];
    } finally {
      this.loading = false;
    }
  }

  sameQuery(newQuery: QueryListInvolvedCompanies): boolean {
    return (
      newQuery &&
      this.query?.exporterId === newQuery?.exporterId &&
      this.query?.profileCode === newQuery?.profileCode &&
      this.query?.PageIndex === newQuery?.PageIndex &&
      this.query?.PageSize === newQuery?.PageSize
    );
  }

  async pageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    await this.getListInvolvedCompanies();
  }

  radioChange(event) {
    event.value.typeCompany = this.typeCompany;
    this.onChangeRadioTable();
    this.companySelected.emit(event.value);
  }

  onChangeRadioTable() {
    this.radioStatus = false;
  }

  closeTable() {
    this.closeTableEvent.emit(this.typeCompany);
  }

  openDialogNewCompany(companyToEdit?: any) {
    if (companyToEdit) {
      this.handleModalEditCompany(companyToEdit);
    } else {
      this.handleModalEditCompany(companyToEdit);
    }
  }

  async handleModalEditCompany(companyToEdit: any) {
    this.dialogRefEditCompany = this.dialog
      .open(AddNotEllosCompanyManagerDialogComponent, {
        width: '500px',
        maxHeight: '85vh',
        disableClose: true,
        data: {
          dataCompanyToEdit: companyToEdit,
          countries: allCountries
        }
      })
      .afterClosed()
      .subscribe(async (res) => {
        await this.getListInvolvedCompanies();
      });
  }

  async removeCompany(companyToRemove: any) {
    this.loading = true;
    let response = await this.companyService.deleteCompanyImpoter(companyToRemove?.id);
    if (response?.success) {
      await this.getListInvolvedCompanies();
    }
    this.loading = false;
  }

  filterPage(page: any) {
    this.queryListInvolvedCompaniesStore.dispatch(pageConfig({ PageIndex: page.pageIndex, PageSize: page.pageSize }));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
